import React from "react";

import arrowIcon from "../../images/arrow.svg";
import { Button } from "../Button/Button";

type TrackCardProps = {
  title?: string;
  description: React.ReactNode;
  buttonText: string;
  buttonLink?: string;
  onButtonClick?: () => void;
  imageSrc: string;
  buttonDisabled?: boolean;
  buttonCompleted?: boolean;
};

export const TrackCard: React.FC<TrackCardProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  onButtonClick,
  imageSrc,
  buttonDisabled,
  buttonCompleted,
}) => {
  return (
    <div className="bg-white rounded-[20px] border border-grey-lighter py-7 px-5 flex flex-col items-center h-full">
      {!!title && (
        <div className="mb-8 font-semibold text-primary-dark">{title}</div>
      )}

      <div className="relative w-full md:h-[300px] h-[140px] mb-8">
        <img
          src={imageSrc}
          alt="Background Image"
          className="w-full h-full md:object-contain rounded-lg"
        />
      </div>

      <div className="flex flex-col justify-between h-full">
        <div className="text-sm text-left">{description}</div>

        <div className="flex flex-col w-full">
          <Button
            href={buttonLink}
            onClick={buttonCompleted ? undefined : onButtonClick}
            rel="noopener noreferrer"
            disabled={buttonDisabled}
            completed={buttonCompleted}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
